<section app-home-banner></section>
<section app-home-story></section>
<section app-home-categories></section>

<section app-home-designed-details></section>
<section app-home-new-arrivals></section>
<section app-home-join></section>